/*
  Cart drawer runtime cloned from tryrosabella.com's `mcart` section.

  The source ships this inline at the bottom of the section; here it is an asset so the
  Section Rendering API responses that <mc-drawer> fetches on every cart change stay pure
  markup. `renderElement` only swaps the innerHTML of .mcart-items-wrapper,
  .condition-slide and .mcart-subtotals, so nothing in this file ever re-executes -- the
  <mc-quantity>/<mc-itemdelete>/<quickadd-prod> elements inside the new markup are
  upgraded by the browser on their own.

  Three changes from the source:

  - `__pagefly_theme_atc_check__` is pinned to "Dawn"; see the comment on it below. This is
    the one addition rather than a port, and it is what makes the drawer open at all.

  - The source theme loads jQuery globally in <head>; Horizon does not. The jQuery half of
    the file is deferred until jQuery is available, and jQuery is loaded from the same URL
    the source uses only when nothing else already put it on the page -- PageFly's runtime
    loads its own copy on product pages, and this waits for that instead of racing it.

  - The section id is `rosa-mcart`, not `mcart`, so <mc-drawer data-id> and the
    `?sections=` / `&sections=` parameters built from it follow the theme's rosa- prefix.

  Everything else is verbatim so the file stays diffable against the source, including the
  console.log calls, the `.ros_selector-*` handlers for product pages that are not cloned
  yet, and the fact that most of the jQuery add-to-cart handlers are dead weight on the
  cloned product pages: they read `data-id` / `data-selling-plan` off
  `.variants-bundles__option input:checked` and `.product_box__sub`, none of which the
  Moringa, Saffron or Gummies bundle pickers carry -- upstream included. On
  tryrosabella.com those handlers POST `id=undefined`, get a 404, and never reach their
  `openCartDrawer()`; PageFly's own form submit is what puts the right variant and selling
  plan in the cart. Same here.
*/
(function () {
  if (window.__rosaMcartInit) return;
  window.__rosaMcartInit = true;

  /* This is what actually opens the drawer after a PageFly add-to-cart.

     PageFly's cart runtime picks a post-add handler with a switch over
     `Shopify.theme.schema_name`. tryrosabella.com reports "Dawn", so it takes the
     _pf_handleFreeShopifyTheme branch: fetch a few Dawn cart sections, look for a
     <cart-drawer> or <cart-notification> element to render them into, and -- finding
     neither, because the site replaced Dawn's cart with this drawer -- fall through to
     clicking #cart-icon-bubble, which the handler at the bottom of this file turns into
     openCartDrawer().

     This theme reports "Horizon", which that switch has no case for, so nothing happened
     at all. Claiming "Dawn" puts us back on the source's path: Horizon has no <cart-drawer>
     or <cart-notification> tag either (its drawer is <theme-drawer id="cart-drawer">
     wrapping <cart-drawer-component>), and the sections PageFly asks for come back as
     `null` with a 200, so the fetch resolves and the fall-through fires.

     PageFly reads this variable at add time, so setting it from a deferred script is early
     enough. */
  if (!window.__pagefly_theme_atc_check__) window.__pagefly_theme_atc_check__ = 'Dawn';


    class McDrawer extends HTMLElement{
      constructor() {
        super()
        this.sectionName = this.dataset.id
      }

      connectedCallback() {
        // this.querySelectorAll(".mcart-prod-add-to-cart").forEach(btn => {
        //   btn.addEventListener("click", this.handleAddOnItem.bind(this))
        // })
      }

      deleteItemEvent(url) {
        this.updateCartItem(url)
      }

      handleAddOnItem(e) {
        this.updateCartItem(e.target.dataset.url)
      }

      updateItemEvent(url, itemWrapper) {
        this.itemWrapper = itemWrapper 
        this.updateCartItem(url)
      }

      handleeQuickAddProduct(url, el) {
        this.quickAddToCartTbn = el
        el.innerHTML = 'Adding To Cart'
        el.setAttribute("disabled", true)
        this.updateCartItem(url)
      }

      updateCartItem(url) {
        url = `${url}&sections=${this.dataset.id}`
        fetch(url)
        .then(res => {
          return res.json()
        })
        .then(res => {
          if(res.errors){
            this.handleErrorMessage(res)
            return
          }
          let html = new DOMParser().parseFromString(res.sections[this.sectionName], 'text/html')
          this.renderElement(html)
        })
        .catch(err => console.log(err))
        .finally(() => {
          if(this.quickAddToCartTbn) {
            this.quickAddToCartTbn.innerHTML = 'Add To Cart'
            this.quickAddToCartTbn.removeAttribute("disabled")
          }
        })
      }

      fetchSection() {
        let parentThis = this
        fetch(`${window.location.pathname}?sections=${this.dataset.id}`)
        .then(res => res.json())
        .then(res => {
           if(res.errors){
            return
          }
          let html = new DOMParser().parseFromString(res[this.sectionName], 'text/html')
          this.renderElement(html)
        })
        .catch(err => console.log(err))
      }

      handleErrorMessage(res) {
        this.itemWrapper.querySelector(".mcart-item-error-msg").innerHTML = res.errors
        this.itemWrapper.classList.add("error")
        setTimeout(() => {
          this.itemWrapper.classList.remove("error")
          this.loadingDisabled()
        }, 2000)
      }

      renderElement(html) {

        if(this.querySelector(".mcart-items-wrapper"))
          this.querySelector(".mcart-items-wrapper").innerHTML = html.querySelector(".mcart-items-wrapper").innerHTML
        if(this.querySelector(".condition-slide"))
          this.querySelector(".condition-slide").innerHTML = html.querySelector(".condition-slide").innerHTML
        if(this.querySelector(".mcart-subtotals"))
          this.querySelector(".mcart-subtotals").innerHTML = html.querySelector(".mcart-subtotals").innerHTML
        if(document.querySelector(".cart_item_count"))
          document.querySelector(".cart_item_count").innerHTML = html.querySelector("mc-drawer").dataset.itemCount

        this.loadingDisabled()
      }

      open() {
        this.fetchSection()
        document.body.style.overflow = 'hidden'
        this.querySelector(".my-cart-sec").classList.add("active")
      }
      close() {
        document.body.style.overflow = 'unset'
        this.querySelector(".my-cart-sec").classList.remove("active")
      }

      loadingEnabled() {
        this.querySelector(".mcart-container").classList.add("loading")
      }
      loadingDisabled() {
        this.querySelector(".mcart-container").classList.remove("loading")
      }

      debounce(fn, wait) {
        let t;
        return (...args) => {
          clearTimeout(t);
          t = setTimeout(() => fn.apply(this, args), wait);
        };
      }
    }

    customElements.define("mc-drawer", McDrawer)

    window.openCartDrawer = () => document.querySelector("mc-drawer").open()
    window.closeCartDrawer = () => document.querySelector("mc-drawer").close()
    window.updateCartDrawer = () => document.querySelector("mc-drawer").fetchSection()



    class McQuantity extends HTMLElement{
      constructor() {
        super()
      }

      connectedCallback() {
        this.btns = this.querySelectorAll("button")
        this.qtyElement = this.querySelector("p")

        this.btns.forEach(btn => btn.addEventListener("click", this.handleEvent.bind(this)))
      }

      handleEvent(e) {
        let url = '/cart.json',
        wrapper = e.target.closest(".mcart-item")
        if(e.target.tagName === "BUTTON")
          url = e.target.dataset.url
        if(e.currentTarget.tagName === "BUTTON")
          url = e.currentTarget.dataset.url

        let drawer = this.closest("mc-drawer")
        drawer.loadingEnabled()
        drawer.updateItemEvent(url, wrapper)
      }

      debounce(fn, wait) {
        let t;
        return (...args) => {
          clearTimeout(t);
          t = setTimeout(() => fn.apply(this, args), wait);
        };
      }
    }

    customElements.define("mc-quantity", McQuantity)

    class McItemDelete extends HTMLElement{
      constructor() {
        super()
      }

      connectedCallback() {
        this.addEventListener("click", this.handleEvent.bind(this))
      }

      handleEvent(e) {
        let drawer = this.closest("mc-drawer")
        drawer.loadingEnabled()
        drawer.deleteItemEvent(this.dataset.url)
      }
    }
    customElements.define("mc-itemdelete", McItemDelete)


    class QuickAddProduct extends HTMLElement{
      constructor() {
        super()
      }

      connectedCallback() {
        this.addEventListener("click", this.handleEvent.bind(this))
        this.button = this.querySelector("button")
      }

      handleEvent(e) {
        let drawer = this.closest("mc-drawer")
        drawer.loadingEnabled()
        drawer.handleeQuickAddProduct(this.dataset.url, this.button)
      }
    }
    customElements.define("quickadd-prod", QuickAddProduct)


    window.customFormSubmit = () => {
      document.querySelectorAll(".product-form__submit").forEach(btn => {
        btn.addEventListener("click", e => {
          e.preventDefault();
          let form = btn.closest("form")
          let formData = new FormData(form)
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            body: formData
          })
          .then(response => {
            return response.json();
          })
          .then(response => {
            openCartDrawer()
          })
          .catch((error) => {
            console.error('Error:', error);
          });
        })
      })
    }

    // ========================== Subscription Upgrade ==========================
    document.addEventListener('click', function(e) {
      if (e.target.matches('.cd__item-upgrade')) {
        const btn = e.target;
        const cartItem = btn.closest('.cd__item-upgrade-wrapper').previousElementSibling;
        if (!cartItem || !cartItem.classList.contains('mcart-item')) {
          console.log('No cart item found');
          return;
        }
        btn.querySelector('.cd__item-upgrade-btn')?.classList.toggle('active');
        cartItem.classList.add('loading');

        const id = btn.dataset.id, planId = btn.dataset.planId;
        fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: `id=${encodeURIComponent(id)}&selling_plan=${encodeURIComponent(planId)}`
        })
        .then(openCartDrawer)
        .finally(() => cartItem.classList.remove('loading'));
      }
    });
    // ========================== Subscription Upgrade END ==========================

  /* ---------------------------------------------------------------------------
     jQuery half: the add-to-cart bindings. Runs as soon as jQuery shows up.
     --------------------------------------------------------------------------- */
  function bindJqueryHandlers($) {
      $('.pf_gempages_atc_button').click(function(evt){
        evt.preventDefault();
        console.log('clicked');
        var currentId = $('.variants-bundles__option input:checked').attr('data-id');
        console.log(currentId, 'current id is');
        var isSub = $('#auto_refill:checked');
        var sellingPlanId = $('.variants-bundles__option input:checked').attr('data-selling-plan');

        if (isSub.length > 0) {
           console.log(isSub, 'IS SUB');
           var data = {
             id: currentId,
             quantity: 1,
             selling_plan: sellingPlanId
           };
        } else {
           var data = {
              id: currentId,
              quantity: 1
           };
        }

        jQuery.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: data,
            dataType: "json",
            success: function () {
               openCartDrawer();
            },
        });
      });

      $('.ros_atc_button__mn').click(function(evt){
        evt.preventDefault();
        console.log('clicked');
        var currentId = $('.variants-bundles__option input:checked').attr('data-id');
        console.log(currentId);
        var isSub = $('#auto_refill:checked');
        var sellingPlanId = $('.variants-bundles__option input:checked').attr('data-selling-plan');

        if (isSub.length > 0) {
           console.log(isSub, 'IS SUB');
           var data = {
             id: currentId,
             quantity: 1,
             selling_plan: sellingPlanId
           };
        } else {
           var data = {
              id: currentId,
              quantity: 1
           };
        }

        jQuery.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: data,
            dataType: "json",
            success: function () {
               openCartDrawer();
            },
        });
      });


      $('.variants-bundles__option input').change(function(){
        var currentId = $(this).attr('data-id');
        $('.ros_price__box').addClass('hidden');
        $('.ros_price__box[data-id="'+currentId+'"]').removeClass('hidden');
      });

      $('#auto_refill').change(function(){
        if ($(this).prop('checked')) {
            console.log('Checkbox is checked');
          $('.price-info[data="sub"]').css('display', 'flex');
          $('.price-info[data="otp"]').hide();
          $('.ros_price_box_outer[data="otp"]').addClass('hidden');
          $('.ros_price_box_outer[data="sub"]').removeClass('hidden');
        } else {
            console.log('Checkbox is unchecked');
          $('.price-info[data="sub"]').hide();
          $('.price-info[data="otp"]').css('display', 'flex');
          $('.ros_price_box_outer[data="otp"]').removeClass('hidden');
          $('.ros_price_box_outer[data="sub"]').addClass('hidden');
        }
    });

      $('.homepage-collection_atc').click(function(evt){
        evt.preventDefault();
        var currentId = $(this).attr('data-id');
        var data = {
           id: currentId,
           quantity: 1
         };
        jQuery.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: data,
            dataType: "json",
            success: function () {
               openCartDrawer();
            },
        });
      });


      $('.pf_gempages_atc_button_upd').click(function(evt){
         evt.preventDefault();

         var modeBtn = $(this).attr('data');

          var isSub = $('#auto_refill:checked');
          if (modeBtn == 'subOnly'){
            isSub = true;
         }
          var sellingPlanId = $('.variants-bundles__option input:checked').attr('data-selling-plan');
          var items = [];

          if (isSub.length > 0 || isSub == true) {
            var currentId = $('.product_box__sub .variants-bundles__option input:checked').attr('data-id');

            var currentGiftId = $('.product_box__sub .variants-bundles__option input:checked').attr('data-gift-id');

            if (currentGiftId && currentGiftId.trim() !== '') {
              var multiple = true;
              items.push({ id: currentGiftId, quantity: 1 });
              items.push({ id: currentId, quantity: 1, selling_plan: sellingPlanId });
            }
            else{
              console.log(isSub, 'IS SUB');
               var data = {
                 id: currentId,
                 quantity: 1,
                 selling_plan: sellingPlanId
               };
            }
          } else {
            var currentId = $('.product_box__otp .variants-bundles__option input:checked').attr('data-id');
             var data = {
                id: currentId,
                quantity: 1
             };
          }

        if (multiple == true){
          $.ajax({
              type: "POST",
              url: "/cart/add.js",
              data: {
                items: items,
              },
              dataType: "json",
              success: function (data) {
                 openCartDrawer();
              },
              error: function () {
                alert("Error adding the items to the cart.");
              },
            });
        }
        else{
          console.log(data, 'DATA');
          jQuery.ajax({
              type: "POST",
              url: "/cart/add.js",
              data: data,
              dataType: "json",
              success: function () {
                 openCartDrawer();
              },
          });
        }


      });

      $('.ros_selector-cell').click(function(){
        $('.ros_selector-cell').removeClass('active');
        $(this).addClass('active');
        var currentId = $(this).attr('data-id');

        $('.ros_selector-atc-price').addClass('hided');
        $('.ros_selector-atc-price[data-id="'+currentId+'"]').removeClass('hided');

        $('.ros_selector-once_title').addClass('hided');
        $('.ros_selector-once_title[data-id="'+currentId+'"]').removeClass('hided');

        $('.ros_gifts-container').addClass('hided');
        $('.ros_gifts-container[data-id="'+currentId+'"]').removeClass('hided');
      });

      $('.ros_selector-mode-selection').click(function(evt){
        evt.preventDefault();
        console.log('clicked');
        var currentId = $('.ros_selector-cell.active').attr('data-otp-id');
        var data = {
              id: currentId,
              quantity: 1
        };

        jQuery.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: data,
            dataType: "json",
            success: function () {
               openCartDrawer();
            },
        });
      });


      $('.ros_selector-atc').click(function(evt){
        evt.preventDefault();
        console.log('clicked');
        var currentId = $('.ros_selector-cell.active').attr('data-id');
        var sellingId = $('.ros_selector-cell.active').attr('data-sub');
        var giftId = 46817547944191;

        var  items = [];
        items.push({
          id: currentId,
          quantity: 1,
          selling_plan: sellingId
        });
        if (currentId == '46775597465855' || currentId == '46408416755967'){
          items.push({
            id: giftId,
            quantity: 1
          });
        }



        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            items: items,
          },
          dataType: "json",
          success: function (data) {
            openCartDrawer();
          },
          error: function () {
            alert("Error adding the items to the cart.");
          },
        });

      });

      $('.pp_gempages_atc_button').click(function(evt){
        evt.preventDefault();
        console.log('clicked');
        var currentId = $('.variants-bundles__option input:checked').attr('data-id');
        console.log(currentId);
        var isSub = $('#auto_refill:checked');
        var sellingPlanId = $('.variants-bundles__option input:checked').attr('data-selling-plan');

        if (isSub.length > 0) {
           console.log(isSub, 'IS SUB');
           var data = {
             id: currentId,
             quantity: 1,
             selling_plan: sellingPlanId
           };
        } else {
           var data = {
              id: currentId,
              quantity: 1
           };
        }

        jQuery.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: data,
            dataType: "json",
            success: function () {
               openCartDrawer();
            },
        });
      });

  }

  function whenJquery(run) {
    if (window.jQuery) return run(window.jQuery);

    var waited = 0;
    var poll = setInterval(function () {
      if (window.jQuery) {
        clearInterval(poll);
        run(window.jQuery);
      } else if ((waited += 100) >= 3000) {
        /* Nothing else is bringing jQuery to this page (PageFly only loads it on the
           product pages it renders), so fetch the copy the source theme uses. */
        clearInterval(poll);
        var s = document.createElement('script');
        s.src = 'https://ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js';
        s.onload = function () { run(window.jQuery); };
        document.head.appendChild(s);
      }
    }, 100);
  }

  whenJquery(bindJqueryHandlers);

    customFormSubmit()

    if(document.querySelector(".new-header-cart-icon")) document.querySelector(".new-header-cart-icon").addEventListener("click", e => {e.preventDefault(); openCartDrawer()});
    if(document.querySelector(".mcart-close-btn")) document.querySelector(".mcart-close-btn").addEventListener("click", closeCartDrawer);
    const myCart = document.querySelector(".my-cart");
    if (myCart) {
      myCart.addEventListener("click", function(e) {
        // Only close if .my-cart is currently open (.active) and click is outside .mcart-container
        if (myCart.classList.contains("active") && !e.target.closest('.mcart-container')) {
          closeCartDrawer();
        }
      });
    }
})();
